import ProductCategoryModelBase from '../_generated/modelBases/product-category-model-base';

export default class ProductCategoryModel extends ProductCategoryModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
